import React from "react";
import {
  entryRevenueTypeOptions,
  revenueTypeLabelForDisplay,
} from "../../../utils/tenancyRevenueBreakdown";

export default function RevenueTypeSelect({
  value,
  onChange,
  disabled,
  id,
  selectClassName,
  frequency,
}) {
  const v = String(value || "").trim();
  // Frequency-aware entry options (Setup-Fee intake safety): one_time offers ONLY
  // setup_fee; recurring offers rent/service_fee/utilities. furniture/cleaning/other are
  // never offered for a NEW value.
  const options = entryRevenueTypeOptions(frequency);
  const known = options.some((o) => o.value === v);
  // An existing legacy/other value not in the entry set is rendered as an extra option so
  // the row still DISPLAYS correctly in edit mode (readability preserved). Saving an
  // unsafe one_time value is rejected by the backend — this only keeps the label visible.
  const selectValue = v || (options[0] ? options[0].value : "rent");
  return (
    <select
      id={id}
      className={`${selectClassName} ${disabled ? "cursor-default" : "cursor-pointer"}`}
      value={selectValue}
      onChange={onChange}
      disabled={disabled}
    >
      {v && !known ? (
        <option value={v}>{revenueTypeLabelForDisplay(v)}</option>
      ) : null}
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
